module.exports = {"createFolder":"Cr�er le dossier","parentFolder":"Dossier parent","newFolderName":"Nouveau nom de dossier","uploadDocument":"T�l�charger un document","folder":"Dossier","documents":"Documents","uploadedFilesLength":"Longueur des fichiers t�l�charg�s�:","upload":"T�l�charger","totalFilesLength":"Longueur totale des fichiers�:"}


//////////////////
// WEBPACK FOOTER
// ./ClientApp/locales/technicaldocumentation/fr.json
// module id = gqzI
// module chunks = 1